import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { apiClient, handleApiResponse } from '@/services/api'
import { useAuthStore } from '@/stores/authStore'

// Simple in-memory resource cache
const cache: Record<string, any> = {}

export async function loadLocale(locale: string, namespaces?: string[]): Promise<void> {
  const key = `${locale}|${(namespaces||[]).join(',')}`
  if (cache[key]) return
  const params: any = { locale }
  if (namespaces && namespaces.length) params.namespaces = namespaces.join(',')
  const res = await apiClient.get(`/i18n/resources`, params)
  const data = handleApiResponse<any>(res)
  const resources = data.resources || {}
  Object.keys(resources).forEach((ns) => {
    if (!i18n.hasResourceBundle(locale, ns)) {
      i18n.addResourceBundle(locale, ns, resources[ns], true, true)
    } else {
      i18n.addResources(locale, ns, resources[ns])
    }
  })
  cache[key] = true
}

const detected = (navigator.language || 'en').split('-')[0]

i18n
  .use(initReactI18next)
  .init({
    lng: detected,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    defaultNS: 'common',
    resources: {},
  })

// Bootstrapping: try to load detected language common namespace
// Note: we avoid awaiting here; pages should call loadLocale for specific namespaces
loadLocale(detected, ['common']).catch(() => {})

export default i18n
